<div class="global-search">
  <h2 class="global-search-title">Intelli-Point Search</h2>

  <div class="global-search-box">
    <i class="fas fa-search global-search-icon"></i>
    <input type="text" class="global-search-input" placeholder="Search"
           [(ngModel)]="searchText" (ngModelChange)="onTextChanged()" (keydown.escape)="clear()"
           autocomplete="off" spellcheck="false" aria-label="Search" />
    <button type="button" class="global-search-clear" *ngIf="searchText" (click)="clear()" title="Clear search" aria-label="Clear search">
      <i class="fas fa-times"></i>
    </button>
  </div>

  <div class="global-search-results" *ngIf="searchText.trim().length > 0" aria-live="polite">
    <div class="global-search-status" *ngIf="tooShort">Type at least 2 characters to search</div>

    <div class="global-search-status" *ngIf="searching">Searching ...</div>

    <!-- Shown as soon as the browser's own matches are in; the server's are merged in when they arrive -->
    <ng-container *ngIf="!searching && searched">
      <div class="global-search-status" *ngIf="outcome.total > 0">
        {{ outcome.total }} {{ outcome.total === 1 ? 'result' : 'results' }}<span *ngIf="outcome.pending"> so far</span>
        <span *ngIf="outcome.pending"> · searching for more ...</span>
        <span *ngIf="refreshing"> · updating results ...</span>
      </div>
      <div class="global-search-status" *ngIf="outcome.total === 0 && (outcome.pending || refreshing)">
        {{ refreshing ? 'Updating results ...' : 'Searching for more ...' }}
      </div>
      <div class="global-search-status" *ngIf="outcome.total === 0 && !outcome.pending && !refreshing">
        No results for "{{ searchText.trim() }}"
      </div>
      <div class="global-search-warning" *ngIf="outcome.incomplete">
        Some results could not be loaded. Try again in a moment.
      </div>

      <div class="result-group" *ngFor="let group of outcome.groups; trackBy: trackByType">
        <div class="result-group-label">{{ group.label }}</div>

        <div class="result" *ngFor="let result of visibleResults(group); trackBy: trackByResult">
          <div class="result-path">{{ group.pageName }}<span *ngIf="result.subtitle"> › {{ result.subtitle }}</span></div>
          <a class="result-title" [routerLink]="result.link.route" [queryParams]="result.link.queryParams" (click)="onResultClick()">{{ result.title }}</a>
          <div class="result-snippet">
            <span class="result-field">{{ result.matchedField }}:</span>
            <ng-container *ngFor="let part of snippetParts(result)"><b *ngIf="part.match">{{ part.text }}</b><ng-container *ngIf="!part.match">{{ part.text }}</ng-container></ng-container>
          </div>
          <div class="result-extra" *ngIf="result.extraLinks.length > 0">
            <a *ngFor="let link of result.extraLinks" [routerLink]="link.route" [queryParams]="link.queryParams" (click)="onResultClick()">{{ link.label }}</a>
          </div>
        </div>

        <button type="button" class="result-more" *ngIf="hiddenCount(group) > 0" (click)="showMore(group)">
          Show {{ hiddenCount(group) }} more {{ group.label.toLowerCase() }}
        </button>
      </div>
    </ng-container>
  </div>
</div>
